import { RootState } from 'typesafe-actions';

export const getLayers = ({ layers }: RootState) => layers;
